<div mat-dialog-content class="all">
  <lemon-dialog-header>
    {{ 'lasku.sposti-dialog.laheta-lasku-spostilla' | translate | async }}
  </lemon-dialog-header>

  <div class="containerii" style="backface-visibility: hidden">
    <div class="keskitettava">
      <form (ngSubmit)="send()" novalidate>
        <div style="margin-bottom: 0.5em">
          <mat-chip-grid #vastaanottajaChips style="margin-bottom: 0.5em">
            @for (vastaanottaja of email.vastaanottajat; track vastaanottaja) {
              <mat-chip-option [selectable]="false" [removable]="true" (removed)="poistaAsiakas(vastaanottaja)">
                {{ vastaanottaja }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-option>
            }
          </mat-chip-grid>
        </div>
        <mat-form-field>
          <mat-label>{{ 'lasku.sposti-dialog.lisaavastaanottaja' | translate | async }}</mat-label>
          <input type="email" autocomplete="kirjanpitotietoarkki" [matChipInputFor]="vastaanottajaChips" cdkFocusRegionstart (blur)="lisaa()" [formField]="lomake.lisaavastaanottaja" (matChipInputTokenEnd)="lisaa()" matInput data-lpignore="true" />
          <!-- <mat-icon matSuffix (click)="lisaa()">add</mat-icon> -->
          <mat-error>{{ fieldErrors.lisaavastaanottaja }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'lasku.sposti-dialog.aihe' | translate | async }}</mat-label>
          <input #aihe type="text" [formField]="lomake.aihe" matInput />
          <mat-error>{{ fieldErrors.aihe }}</mat-error>
        </mat-form-field>

        <mat-form-field style="margin-top: 20px">
          <mat-label>{{ 'lasku.sposti-dialog.otsikko' | translate | async }}</mat-label>
          <input type="text" [formField]="lomake.otsikko" matInput />
          <mat-error>{{ fieldErrors.otsikko }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'lasku.sposti-dialog.teksti' | translate | async }}</mat-label>
          <textarea rows="2" [formField]="lomake.teksti" matInput cdkTextareaAutosize></textarea>
          <mat-error>{{ fieldErrors.teksti }}</mat-error>
        </mat-form-field>
      </form>

      @if (asetuksissaOnOletustietojaVirhe) {
        <div class="red-text" style="margin-top: 1em; margin-bottom: 1em">
          {{ 'lasku.validation.asetukset.oletuksia-sposti' | translate | async }}
        </div>
      }

      <div style="display: flex; align-items: center; justify-content: center; margin-top: 1em">
        <app-primary-button (click)="send()" [disabled]="!lomake().valid()" actionId="Lähetti laskun tiedoilla" [actionContext]="$any(lomake().value())">
          {{ 'lasku.sposti-dialog.laheta' | translate | async }}
        </app-primary-button>
      </div>
    </div>
    <div class="keskitettava">
      <div style="margin: 0; font-size: 15px" class="light-blue-text">{{ 'lasku.sposti-dialog.esikatselu' | translate | async }}</div>
      <lasku-email-esikatselu-perinteinen [varit]="varit" [tiedot]="esikatselutiedot | async"></lasku-email-esikatselu-perinteinen>
    </div>
  </div>
</div>
